import React, { useState } from 'react';
import { Heading } from '@klp/design/Heading';
import { IconName, Illustration } from '@klp/design/Illustrations';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    IconButton,
    Switch,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
    contextSelectorActions,
    contextSelectors,
} from '@klp/contextSelector/store/contextSelectorSlice';

type ByggSelectorSettingsDialogProps = {
    open: boolean;
    onClose: () => void;
};
export const ByggSelectorSettingsDialog: React.FC<
    ByggSelectorSettingsDialogProps
> = ({ open, onClose }) => {
    const dispatch = useDispatch();
    const { showByggGrunn } = useSelector(contextSelectors);
    const [toggleShowBygg, setToggleShowBygg] = useState(showByggGrunn ?? true);
    const { t } = useTranslation();

    const { saveShowByggGrunnToStorage } = contextSelectorActions;

    const handleToggleShowBygg = () => {
        setToggleShowBygg(!toggleShowBygg);
    };

    const handleSaveChanges = () => {
        dispatch(saveShowByggGrunnToStorage(toggleShowBygg));
        onClose();
    };
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="dialog-title"
            fullWidth={true}
        >
            <DialogTitle id="dialog-title">
                <Grid container={true} justifyContent="space-between">
                    <Grid item={true}>
                        <Heading
                            klpHeadingLevel="FOUR"
                            translation="bygg.settings.title"
                        >
                            {t('bygg.settings.title')}
                        </Heading>
                    </Grid>
                    <Grid item={true}>
                        <IconButton onClick={onClose}>
                            <Illustration icon={IconName.CLOSE} size="small" />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <FormControlLabel
                    control={
                        <Switch
                            checked={toggleShowBygg}
                            onChange={handleToggleShowBygg}
                            name="toggleShowBygg"
                            color="primary"
                        />
                    }
                    label={t('bygg.settings.showByggGrunn')}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSaveChanges}
                >
                    {t('bygg.settings.saveChanges')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
